import axios from "axios";
import {detailServicesPath} from "../../../Constants";

const detailControllerRestUrl = detailServicesPath + '/organizations/variables'

export default class VariableControllerServiceOrganization {
    static async get(detailId) {
        return axios.get(`${detailControllerRestUrl}?detailId=${detailId}`);
    }

    static async save(detailId, data) {
        return await axios.post(`${detailControllerRestUrl}?detailId=${detailId}`, JSON.stringify(data), {
            headers: {
                'Content-Type': 'application/json'
            }
        });
    }

    static async delete(variableId) {
        return await axios.delete(`${detailControllerRestUrl}/${variableId}`, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
    }

    static async edit(variableId, data) {
        return await axios.put(`${detailControllerRestUrl}/${variableId}`, JSON.stringify(data), {
            headers: {
                'Content-Type': 'application/json'
            }
        });
    }

    static async prevAll(detailId, data) {
        return await axios.post(`${detailControllerRestUrl}/preview-all?detailId=${detailId}`, JSON.stringify(data), {
            headers: {
                'Content-Type': 'application/json'
            }
        });
    }
}
